'use client';

import { useState } from 'react';

import { Container, Link, Modal, ModalBody, Section, Spacer, SpacerSize, TrilogyColor } from '@bytel/trilogy-react';

import { SSIBlock } from '@components/ssi-block';

import { Faq } from '../../faq';
import { FinePrint } from './fine-print';
import { HomeBreadcrumb } from './home-breadcrumb';

type PageBottomContentProps = {
    mobilePlanFirst: boolean;
};
export default function PageBottomContent({ mobilePlanFirst }: Readonly<PageBottomContentProps>) {
    const [shouldShowMentionsModal, setShouldShowMentionsModal] = useState(false);

    return (
        <Section backgroundColor={TrilogyColor.NEUTRAL_FADE}>
            <Container medium>
                <Faq isMobilePlan={mobilePlanFirst} />

                <Link
                    className='button-clear has-text-centered is-block'
                    onClick={() => setShouldShowMentionsModal(true)}
                >
                    Mentions légales
                </Link>

                <FinePrint />
                <Spacer size={SpacerSize.FIVE} />
                <HomeBreadcrumb isMobilePlan={mobilePlanFirst} />

                <Modal
                    active={shouldShowMentionsModal}
                    onClose={() => setShouldShowMentionsModal(false)}
                    title='Mentions légales'
                >
                    <ModalBody>
                        <SSIBlock url='/partials/mentions_legales/emplacements/forfaits-mobiles_sans-engagement' />
                    </ModalBody>
                </Modal>
            </Container>
        </Section>
    );
}
